(function () {
  const config = window.QubitLiveSearch || {};
  const ajaxUrl = config.ajaxUrl || '';
  const nonce = config.nonce || '';
  const minChars = Number(config.minChars || 2);
  const noResults = config.noResults || 'No results found.';
  if (!ajaxUrl) return;

  const inputs = Array.from(
    document.querySelectorAll('[data-live-search-input]')
  );
  if (!inputs.length) return;

  const escapeHtml = (str) =>
    (str || '').replace(/[&<>"']/g, (m) => ({
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#39;',
    }[m]));

  const ensureContainer = (input) => {
    const wrap =
      input.closest('[data-live-search-wrap]') || input.parentElement;
    if (!wrap) return null;
    let results = wrap.querySelector('[data-live-search-results]');
    if (!results) {
      results = document.createElement('div');
      results.className = 'live-search__results';
      results.setAttribute('data-live-search-results', '');
      results.setAttribute('aria-live', 'polite');
      results.setAttribute('aria-atomic', 'true');
      wrap.appendChild(results);
    }
    return results;
  };

  const renderResults = (container, items, query) => {
    if (!container) return;
    if (!query || !items.length) {
      container.innerHTML = items.length
        ? ''
        : `<div class="live-search__empty">${escapeHtml(noResults)}</div>`;
      container.classList.toggle('is-visible', !!query);
      container.classList.remove('is-loading');
      return;
    }

    const listHtml = items
      .map(
        (item) => `
        <li>
          <a class="live-search__item" href="${escapeHtml(item.url)}">
            <span class="live-search__title">${escapeHtml(item.title)}</span>
            <span class="live-search__meta">${escapeHtml(item.type || '')}${
          item.excerpt ? ' · ' + escapeHtml(item.excerpt) : ''
        }</span>
          </a>
        </li>`
      )
      .join('');

    container.innerHTML = `<ul class="live-search__list">${listHtml}</ul>`;
    container.classList.add('is-visible');
    container.classList.remove('is-loading');
  };

  const debounce = (fn, delay) => {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn(...args), delay);
    };
  };

  const fetchResults = async (query) => {
    const body = new URLSearchParams();
    body.append('action', 'qubit_live_search');
    body.append('nonce', nonce);
    body.append('s', query);

    try {
      const response = await fetch(ajaxUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        },
        body: body.toString(),
      });
      if (!response.ok) return [];
      const json = await response.json();
      if (!json || !json.success) return [];
      return json.data?.results || [];
    } catch (err) {
      return [];
    }
  };

  inputs.forEach((input) => {
    const container = ensureContainer(input);
    let lastQuery = '';
    const runSearch = debounce(async () => {
      const query = input.value.trim();
      if (query === lastQuery) return;
      lastQuery = query;
      if (!query || query.length < minChars) {
        renderResults(container, [], '');
        return;
      }
      if (container) {
        container.classList.add('is-loading');
        container.innerHTML = Array.from({ length: 3 }, () =>
          '<div class="live-search__skeleton"><div class="live-search__skeleton-line"></div><div class="live-search__skeleton-line live-search__skeleton-line--short"></div></div>'
        ).join('');
      }
      const items = await fetchResults(query);
      renderResults(container, items, query);
    }, 180);

    input.addEventListener('input', runSearch);
    input.addEventListener('focus', () => {
      const query = input.value.trim();
      if (query && container) container.classList.add('is-visible');
    });
  });
})();
